import _ from 'lodash';
import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { isCurrentUrl } from '@bibliocommons/utils-browser';
import updateSearchQuery from '../helpers/search/updateSearchQuery';

const ApiMethods = {
  getTerm: 'getTerm',
  setTerm: 'setTerm',
  toggleFilterLock: 'toggleFilterLock',
  sessionChanged: 'sessionChanged',
  setSearchType: 'setSearchCategory',
  getSearchType: 'getSearchCategory',
  getSearchTarget: 'getSearchTarget',
  setSearchTarget: 'setSearchTarget',
  onSearch: 'onSearch'
};

const propTypes = {
  headerTemplate: PropTypes.string,
  dispatch: PropTypes.func,
  router: PropTypes.object.isRequired,
  searchTerm: PropTypes.string,
  searchCategory: PropTypes.string,
  locked: PropTypes.bool,
  loggedIn: PropTypes.bool,
  isAdvancedSearch: PropTypes.bool,
  activeFilters: ImmutablePropTypes.map
};

const isNERFLink = (e) => e.target.nodeName === 'A' &&
  e.target.pathname.match('/v2/') && !isCurrentUrl(e.target.href);

const isAdvancedSearchLink = (e) => e.target.nodeName === 'A' &&
  e.target.search.match('custom_edit') && !isCurrentUrl(e.target.href);

export class CoreHeaderContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleNERFLink', 'onSearch', 'initHeader');
    this.headerApi = null;
  }

  componentDidMount() {
    if (this.props.headerTemplate) {
      this.initHeader();
      this.updateHeaderSearchForm();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.headerTemplate) {
      return;
    }

    if (nextProps.loggedIn !== this.props.loggedIn) {
      this.headerApi(ApiMethods.sessionChanged);
    }
    if (nextProps.locked !== this.props.locked) {
      this.headerApi(ApiMethods.toggleFilterLock, nextProps.locked);
    }

    if (nextProps.searchTerm !== this.props.searchTerm) {
      this.headerApi(ApiMethods.setTerm, nextProps.searchTerm);
    }

    if (nextProps.searchCategory !== this.props.searchCategory) {
      this.headerApi(ApiMethods.setSearchType, nextProps.searchCategory);
    }
  }

  updateHeaderSearchForm() {
    if (!this.props.isAdvancedSearch) {
      this.headerApi(ApiMethods.setTerm, this.props.searchTerm);
      this.headerApi(ApiMethods.setSearchType, this.props.searchCategory);
      this.headerApi(ApiMethods.toggleFilterLock, this.props.locked);
    }
  }

  initHeader() {
    this.headerApi = window.BCHeaderPublic;
    this.headerApi(ApiMethods.onSearch, 'catalogue', this.onSearch);
  }

  isSearchSupported() {
    const searchType = this.headerApi(ApiMethods.getSearchTarget);
    const searchCategory = this.headerApi(ApiMethods.getSearchType);

    const isCatalogSearch = searchType === 'catalogue';
    const isSupportedSearchCategory = !_.includes(['user', 'userlist'], searchCategory);
    return isCatalogSearch && isSupportedSearchCategory;
  }

  isOnSearchPage() {
    return this.props.router.location.pathname === '/v2/search';
  }

  onSearch() {
    // Automatically hides keyboard on iOS
    if (__CLIENT__) {
      document.activeElement.blur();
    }


    if (this.isOnSearchPage() && this.isSearchSupported()) {
      const { router, activeFilters, location, locked } = this.props;

      const query = updateSearchQuery({
        currentQuery: location.query,
        activeFilters: locked && activeFilters,
        query: this.headerApi(ApiMethods.getTerm),
        searchType: this.headerApi(ApiMethods.getSearchType),
        pagination_page: undefined
      });

      router.push({ ...location, query });
    } else {
      this.headerApi('performDefaultSearch');
    }
  }

  handleNERFLink(e) {
    if (isNERFLink(e) && !isAdvancedSearchLink(e)) {
      e.preventDefault();
      this.props.router.push(e.target.href);
    }
  }

  render() {
    if (this.props.headerTemplate) {
      return (
        <div className="cp-core-external-header">
          { /* eslint-disable */}
          <div ref="headerWrapper" data-testid="headerWrapper" onClick={this.handleNERFLink} dangerouslySetInnerHTML={{ __html: this.props.headerTemplate }} />
          { /* eslint-enable */}
        </div>
      );
    }

    return null;
  }
}

function mapStateToProps(state) {
  return {
    headerTemplate: state.getIn(['templates', 'header']),
    locked: state.getIn(['search', 'catalogSearch', 'locked']),
    searchTerm: state.getIn(['search', 'searchForm', 'searchTerm']),
    searchCategory: state.getIn(['search', 'searchForm', 'searchType']),
    isAdvancedSearch: state.getIn(['search', 'catalogSearch', 'searchType']) === 'bl',
    activeFilters: state.getIn(['search', 'catalogSearch', 'activeFilters']),
    loggedIn: !!state.getIn(['auth', 'currentUserId'])
  };
}

CoreHeaderContainer.propTypes = propTypes;

export default withRouter(connect(mapStateToProps)(CoreHeaderContainer));



// WEBPACK FOOTER //
// ./app/containers/CoreHeaderContainer.jsx